import script from "./BaseDispDialog.vue?vue&type=script&setup=true&name=BaseDispDialog&lang=js"
export * from "./BaseDispDialog.vue?vue&type=script&setup=true&name=BaseDispDialog&lang=js"

const __exports__ = script;

export default __exports__